"use strict";

var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } };

module.exports = function PredicatePattern(pred) {
  _classCallCheck(this, PredicatePattern);

  this.matches = pred;
  Object.freeze(this);
};